export interface ReviewMember {
  id: string;
  email: string;
  displayName: string;
  role: string;
}

export function memberName(members: ReviewMember[], id: string | null | undefined): string {
  if (!id) return "Unassigned";
  const member = members.find((candidate) => candidate.id === id);
  return member?.displayName || member?.email || "Unavailable";
}
